import { useSelector } from 'react-redux';

import { enUS } from 'date-fns/locale/en-US';

import { LANGUAGE_LOCALES } from 'components/Datepicker/constants';
import { TRootState } from 'store';
import { IUserState } from 'store/userConfiguration';

export const useDateLocale = () => {
  const { language } = useSelector<TRootState, IUserState>(
    (state) => state.userConfiguration,
  );

  return LANGUAGE_LOCALES[language] || enUS;
};
